export default __webpack_public_path__ + "static/media/submission.c8e69b58.svg";